import axios from "axios"
import VueCookies from 'vue-cookies'
import Vue from "vue"
import qs from 'qs';
import { Loading } from 'element-ui';

var request = axios.create({
  baseURL: window.location.href.indexOf("http://localhost")>-1?'https://api.onesb2c.com/' : window.serverAPI.url,
  timeout: 30000,
  headers: {}
});



var needLoadingRequestCount = 0;
let configUrl = "";
request.interceptors.request.use(function (config) {
  if (config.url != '/Login/UserLogin') {
    config.headers.Authorization = 'Bearer' + ' ' + VueCookies.get('token');
    config.headers.AppToken = VueCookies.get("appToken");


    // config.headers.Authorization = 'Bearer' + ' ' + sessionStorage.getItem("token");
    // config.headers.AppToken = sessionStorage.getItem("appToken");
  }
  configUrl = config.url.split("?")[0];
  if (needLoadingRequestCount === 0 && configUrl != '/back/shopify/orderflow') {
    Loading.service({ background: 'rgba(131, 143, 159, 0.3)' });
  }
  needLoadingRequestCount++;
  // 下面的config.url的参数是不需要&序列化的
  // 处理get请求时参数的特殊字符
  let index = config.url.indexOf("?")
  if (index != -1) {
    let startStr = config.url.slice(0, index);
    let endStr = config.url.slice(index + 1);
    let arr1 = endStr.split("&");
    let STR = "";
    arr1.map(el => {
      let str1 = el.split("=")[0];
      let str2 = el.split("=")[1];
      str2 = encodeURIComponent(str2)
      STR += str1 + "=" + str2 + "&";
    })
    STR = STR.slice(0, STR.length - 1);
    config.url = startStr + "?" + STR;
  }
  if (config.method === "post" && config.data && config.url != '/back/shopify/updateorder' && config.url != '/back/shopify/addtracking' && config.url != '/back/shopify/updatetracking' && config.url != '/back/k5/add' && config.url != '/back/shopify/backtracking' && config.url != '/back/shopify/getorder' && config.url != '/auth/gettoken' && config.url != '/back/k5/update' && config.url != '/shopcategory/add' && config.url != '/goods/add' && config.url != '/goods/ball' && config.url != '/order/get') {
    config.data = qs.stringify(config.data);
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

request.interceptors.response.use(function (response) {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0 && configUrl != "/back/shopify/orderflow") {
    Loading.service().close();
  }
  return response;
}, function (error) {
  if (error.response.status === 401) {
    window.location.href = "/login"
  }
  return Promise.reject(error);
});

export default request;